<script lang="ts" setup>
import { XModal, XLink } from '@clicksign/excalibur';

import { BrandButton } from '~~base-ui';

type DigitalCertificateCloudUnavailableModalEmit = {
  (event: 'try-again',): void;
  (event: 'close'): void;
};

const emit = defineEmits<DigitalCertificateCloudUnavailableModalEmit>();

const HELP_URL = 'http://ajuda.clicksign.com/article/973-certificado-digital-em-nuvem';

const isLoading = ref(false);

function tryAgain() {
  emit('try-again');
}

function close() {
  emit('close');
}
</script>

<template>
  <XModal
    :is-open="true"
    :title="$t('requirement.digitalCertificate.cloud.modal.unavailable.title')"
    :close-button="false"
    data-testid="unavailableModal"
  >
    <template #default>
      <p>{{ $t('requirement.digitalCertificate.cloud.modal.unavailable.description') }}</p>
      <XLink
        :to="HELP_URL"
        data-testid="cloudUnavailableModalLink"
        target="_blank"
      >
        {{ $t('requirement.digitalCertificate.cloud.modal.unavailable.link') }}
      </XLink>
    </template>

    <template #actions>
      <BrandButton
        design="outlined"
        data-testid="modalCloseButton"
        @click="close"
      >
        {{ $t('common.back') }}
      </BrandButton>

      <BrandButton
        :loading="isLoading"
        data-testid="modalTryAgainButton"
        @click="tryAgain"
      >
        {{ $t('common.tryAgain') }}
      </BrandButton>
    </template>
  </XModal>
</template>
